import { Dialog } from '@mui/material';

import styled from 'styled-components';

import { Constants } from '@arrived/common';

export const StyledOfferingDialog = styled(Dialog)`
  .MuiPaper-root {
    width: 100%;
    max-width: 900px;
    padding: 0;
  }

  .header-content {
    background-color: ${({ theme }) => theme.palette.neutrals.milk};
    display: flex;
    flex-direction: row;

    & > * {
      flex: 1 1 50%;
    }
  }

  .header-image {
    display: block;
    width: 50%;
    object-fit: cover;
    min-height: 300px;
  }

  .header-description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing(4, 8)};

    & > *:last-child {
      margin-top: ${({ theme }) => theme.spacing(2)};
    }
  }

  .body-content {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(6)};
    padding: ${({ theme }) => theme.spacing(4, 8)};
  }

  .close-button {
    position: absolute;
    top: ${({ theme }) => theme.spacing(1)};
    right: ${({ theme }) => theme.spacing(1)};

    &:hover {
      background-color: ${({ theme }) => theme.palette.darkened.seal};
    }
  }
`;
